import { ContentGroup, DataGrid, TableCell, theme } from '@ketch-com/deck'
import { GetPermitTransactionV2ResponseBodyIdentitiesItemDTO } from '@ketch-com/figurehead'
import { Box, Typography } from '@mui/material'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium'
import { useAuditLogContext } from 'pages/insights/auditLog/context/AuditLogContext'

const columns: GridColDef<GetPermitTransactionV2ResponseBodyIdentitiesItemDTO>[] = [
  {
    align: 'left',
    field: 'identifier',
    width: 500,
    headerAlign: 'left',
    headerName: 'Identifier',
    renderHeader: params => <Typography variant="smallLabel">{params.colDef.headerName}</Typography>,
    sortable: false,
    renderCell: ({ row: identifier }: GridRenderCellParams<GetPermitTransactionV2ResponseBodyIdentitiesItemDTO>) => {
      return (
        <TableCell>
          <Box
            sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start' }}
          >
            <Typography variant="label">{identifier.name}</Typography>
            <Typography variant="smallBody" color={theme.palette.Text.Secondary}>
              {identifier.space}
            </Typography>
          </Box>
        </TableCell>
      )
    },
  },
  {
    align: 'left',
    field: 'identifierValue',
    flex: 2,
    headerAlign: 'left',
    headerName: 'Value',
    renderHeader: params => <Typography variant="smallLabel">{params.colDef.headerName}</Typography>,
    sortable: false,
    renderCell: ({ row: identifier }: GridRenderCellParams<GetPermitTransactionV2ResponseBodyIdentitiesItemDTO>) => {
      return (
        <TableCell>
          <Typography>{identifier.value}</Typography>
        </TableCell>
      )
    },
  },
]

export const ConsentTabIdentifiers = () => {
  const { consentTransactionData } = useAuditLogContext()

  // Extract unique identities from each transaction
  const rows = consentTransactionData.reduce<GetPermitTransactionV2ResponseBodyIdentitiesItemDTO[]>(
    (acc, transaction) => {
      const identities = transaction.identities || []
      identities.forEach(identity => {
        if (!acc.some(existing => existing.space === identity.space)) {
          acc.push(identity)
        }
      })
      return acc
    },
    [],
  )

  const rowCount = rows.length
  const showPagination = rowCount > 5

  return (
    <ContentGroup
      title="Associated Identifiers"
      titleVariant="h3"
      subTitle="The identifiers present when this consent record was recorded."
    >
      <DataGrid
        autosizeOnMount
        autosizeOptions={{
          expand: true,
          includeHeaders: true,
          includeOutliers: false,
        }}
        getRowHeight={() => 'auto'}
        getRowId={row => row.space}
        columns={columns}
        rows={rows}
        checkboxSelection={false}
        disableRowSelectionOnClick
        disableColumnMenu
        disableColumnPinning
        disableColumnReorder
        disableColumnResize
        disableChildrenSorting={false}
        disableRowHoverStates
        paginationMode="client"
        rowCount={rowCount}
        pagination={showPagination}
        hideFooter={!showPagination}
        pageSizeOptions={[5, 10, 20]}
        noRowsOverlayProps={{ buttonTitle: '' }}
        sx={{
          '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeaderCheckbox):hover': {
            backgroundImage: 'unset',
            cursor: 'auto',
          },
          marginTop: -2,
        }}
      />
    </ContentGroup>
  )
}
